/**
 * Узкоспецифичный стор (НЕ ХРАНЯЩИЙ в себе никакие полные списки объектов), используемый для обмена
 * различными статусами между независимыми виджетами на уровне страницы
 *
 * Пример - статус отображения малой выдачи в блоке карточек, который может быть необходим блоку отзывов
 */
export const useWidgetsShareStore = defineStore('widgets-share', () => {
  /**
   * @see widgets/AllCardsBlock
   * true в случае, если все Э на странице в статусе паузы
   * Выводится сообщение малой выдачи "Экскурсии в <name> временно не проводятся"
   * */
  const isAllExperiencesPaused = ref(false);

  return {
    isAllExperiencesPaused,
  };
});
